<!-- InsertLinkToTextbox.vue -->
<template>
  <div :dir="isHebrew ? 'rtl' : 'ltr'">
    <b-button 
      @click="toggleLinkModal"
      variant="primary"
      class="add-link"
    >
      {{ t('insertLinkAddLinkButton') }}
    </b-button>

    <div v-if="showLinkModal" class="trip-contact-input add-link-block">
      <div class="trip-contact-field">
        <input v-model="linkText" :placeholder="t('insertLinkTextPlaceholder')" />
      </div>
      <div class="trip-contact-field">
        <input 
            v-model="linkUrl"
            :placeholder="t('insertLinkUrlPlaceholder')"
            :dir="isHebrew ? 'rtl' : 'ltr'"
        />
      </div>
      <b-button @click="insertLink" variant="primary" class="insert-link-btn">
        {{ t('insertLinkInsertButton') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { translationMixin } from '@/mixins/translationMixin';

export default {
  name: "InsertLinkToTextbox",
  mixins: [translationMixin],
  props: {
    value: { type: String, required: true }, // the v-model string
    setValue: { type: Function, required: true }, // the setter function
    textareaRef: { type: String, required: true }, // ref name of the textarea
  },
  data() {
    return {
      showLinkModal: false,
      linkText: '',
      linkUrl: ''
    }
  },
  methods: {
    toggleLinkModal() {
      this.showLinkModal = !this.showLinkModal;
    },
    insertLink() {
      console.log('Inserting link...');
      const anchor = `<a href="${this.linkUrl}" target="_blank">${this.linkText}</a>`;
      
      // Try to find the textarea in different scopes
      let textarea = null;
      
      // Try parent first
      if (this.$parent.$refs[this.textareaRef]) {
        textarea = this.$parent.$refs[this.textareaRef];
      }
      
      // Try parent's parent if needed
      else if (this.$parent.$parent && this.$parent.$parent.$refs[this.textareaRef]) {
        textarea = this.$parent.$parent.$refs[this.textareaRef];
      }
      
      // Try parent's parent's parent if needed
      else if (this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.$refs[this.textareaRef]) {
        textarea = this.$parent.$parent.$parent.$refs[this.textareaRef];
      }
            
      if (!textarea) {
        console.error('Could not find textarea with ref:', this.textareaRef);
        console.log('Component hierarchy:', {
          'this.$parent.$refs': this.$parent.$refs,
          'this.$parent.$parent?.$refs': this.$parent.$parent?.$refs,
          'this.$parent.$parent?.$parent?.$refs': this.$parent.$parent?.$parent?.$refs
        });
        return;
      }

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const updatedValue = this.value.substring(0, start) + anchor + this.value.substring(end);
      this.setValue(updatedValue);

      this.showLinkModal = false;
      this.linkText = '';
      this.linkUrl = '';
    }
  }
}
</script>

<style scoped>
.add-link-block {
  background: var(--ride-itinerary-background);
  padding: 15px;
}

.add-link {
  display: block;
  margin-top: 1.5rem !important;
}

  .trip-contact-input{
    position: relative;
  }
  .trip-contact-field img{
    width: 100%;
  }
  .trip-contact-input input,
  .trip-contact-input textarea{
    height: 56px;
    width: 100%;
    background: #FFFFFF;
    border: 2px solid #07A0C3!important;
    border-radius: 45px;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    padding: 10px 20px!important;
    color: black !important;
  }

  [dir="rtl"] .trip-contact-input input:not([dir="ltr"]),
  [dir="rtl"] .trip-contact-input textarea {
    text-align: right;
  }

  [dir="ltr"] .trip-contact-input input:not([dir="ltr"]),
  [dir="ltr"] .trip-contact-input textarea {
    text-align: left;
  }
  .trip-contact-input textarea{
    height: 300px;
  }
  .trip-input-icon {
    position: absolute;
    top: 13px;
    right: 25px;
  }
  .trip-contact-input p{
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    margin:15px 0 0;
    color: rgba(228, 36, 36, 0.6)
  }
.trip-contact-input input::-webkit-input-placeholder,
.trip-contact-input textarea::-webkit-input-placeholder{ /* WebKit, Blink, Edge */
    color: rgba(13, 47, 41, 0.5);
    opacity: 1;
}
.trip-contact-input input:-moz-placeholder,
.trip-contact-input textarea:-moz-placeholder{ /* Mozilla Firefox 4 to 18 */
  color: rgba(13, 47, 41, 0.5);
   opacity:  1;
}
.trip-contact-input input::-moz-placeholder,
.trip-contact-input textarea::-moz-placeholder{ /* Mozilla Firefox 19+ */
  color: rgba(13, 47, 41, 0.5);
   opacity:  1;
}
.trip-contact-input input:-ms-input-placeholder,
.trip-contact-input textarea:-ms-input-placeholder{ /* Internet Explorer 10-11 */
  color: rgba(13, 47, 41, 0.5);
   opacity: 1;
}
.trip-contact-input input::-ms-input-placeholder,
.trip-contact-input textarea::-ms-input-placeholder{ /* Microsoft Edge */
  color: rgba(13, 47, 41, 0.5);
   opacity: 1;
}

.trip-contact-input input::placeholder,
.trip-contact-input textarea::placeholder{ /* Most modern browsers support this now. */
  color: rgba(13, 47, 41, 0.5);
   opacity: 1;
}
.trip-contact-field {
  margin-bottom: 15px;
}

[dir="rtl"] .insert-link-btn {
  align-self: flex-start;
}

.add-link-block {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.trip-contact-field label{
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(13, 47, 41, 0.5)!important;
  display: block;
  margin-bottom: 5px;
  }

  [dir="rtl"] .trip-contact-field label {
    text-align: right;
    margin-right: 40px;
  }

  [dir="ltr"] .trip-contact-field label {
    text-align: left;
    margin-left: 40px;
    margin-right: 0;
  }
  .trip-contact-field label span{
    color: #E42424;
  }





</style>
